import React from 'react';
import './TelegramText.scss';

const TelegramText = (props) => {
    return (
        <p {...props} className={'telegramText ' + props.className}/>
    );
};

export default TelegramText;
